import { BeneficioApi as Api } from "./beneficio.api";

import { AfiliadoService } from "../../../../servicios/cliente/afiliado/afiliado.service";

export class BeneficioFacade {
  static async countByComercioId(comercioId) {
    const afiliadoId = await AfiliadoService.getId();

    return Api.countByAfiliadoIdAndComercioId(afiliadoId, comercioId);
  }

  static async getListByComercioWithPagination(comercioId, pagination) {
    const afiliadoId = await AfiliadoService.getId();

    return Api.getListByAfiliadoIdAndComercioIdWithPagination(
      afiliadoId,
      comercioId,
      pagination
    );
  }
}
